import React from 'react';
import logoBlack from '../assets/webp/logo.webp';

interface IconCircleProps {
  size?: number;
  icon?: React.ReactNode;
  backgroundColor?: string;
}

const IconCircle: React.FC<IconCircleProps> = ({ size = 100, icon, backgroundColor }) => {
  const LogoIcon = () => (
    <img
      src={logoBlack}
      alt="Logo"
      style={{
        objectFit: 'contain',
      }}
    />
  );

  return (
    <div
      className="icon-circle"
      style={{
        width: size,
        height: size,
        borderRadius: '50%',
        background: backgroundColor || '#1A3654',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: size * 0.35,
        color: 'white',
        position: 'relative',
        boxShadow: '0 4px 20px rgba(10, 22, 40, 0.4)',
        border: '3px solid #C9A857',
      }}
    >
      {icon || <LogoIcon />}
    </div>
  );
};

export default IconCircle;
